var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PublicKey } from "@solana/web3.js";
/*
    The transactions provided to this function should be ready to be sent.
    This function will only add the feePayer and blockhash, and then sign, send, and confirm the transaction.
*/
export function sendAndConfirmTransactionsWithRetry(connection, signTransaction, payer, unsignedTransactions, maxRetries) {
    if (maxRetries === void 0) { maxRetries = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var currentRetries, currentIndex, transactionReceipts, transaction, signed, blockhash, e_1, e_2, txid, receipt, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(unsignedTransactions && unsignedTransactions.length)) {
                        return [2 /*return*/, Promise.reject("No transactions provided to send.")];
                    }
                    currentRetries = 0;
                    currentIndex = 0;
                    transactionReceipts = [];
                    _a.label = 1;
                case 1:
                    if (!(!(currentIndex >= unsignedTransactions.length) &&
                        !(currentRetries > maxRetries))) return [3 /*break*/, 13];
                    transaction = unsignedTransactions[currentIndex];
                    signed = null;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, connection.getRecentBlockhash()];
                case 3:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = new PublicKey(payer);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.error(e_1);
                    currentRetries++;
                    //Behavior after this is undefined, so best just to restart and try again.
                    return [3 /*break*/, 1];
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, signTransaction(transaction)];
                case 6:
                    signed = _a.sent();
                    return [3 /*break*/, 8];
                case 7:
                    e_2 = _a.sent();
                    //Eject here because this is most likely an intentional rejection from the user, or a genuine unrecoverable failure.
                    return [2 /*return*/, Promise.reject("Failed to sign transaction.")];
                case 8:
                    _a.trys.push([8, 11, , 12]);
                    return [4 /*yield*/, connection.sendRawTransaction(signed.serialize())];
                case 9:
                    txid = _a.sent();
                    return [4 /*yield*/, connection.confirmTransaction(txid)];
                case 10:
                    receipt = _a.sent();
                    transactionReceipts.push(receipt);
                    currentIndex++;
                    return [3 /*break*/, 12];
                case 11:
                    e_3 = _a.sent();
                    console.error(e_3);
                    currentRetries++;
                    return [3 /*break*/, 12];
                case 12: return [3 /*break*/, 1];
                case 13:
                    if (currentRetries > maxRetries) {
                        return [2 /*return*/, Promise.reject("Reached the maximum number of retries.")];
                    }
                    else {
                        return [2 /*return*/, Promise.resolve(transactionReceipts)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
